<template>
  <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</template>

<script>
export default {
  name: 'BaseSpinner'
}
</script>

<style lang="scss" scoped>

</style>